import { Position, Tooltip as EvergreenTooltip } from 'evergreen-ui'

export default function Tooltip(props: any): JSX.Element {
  if (!props.content) {
    return props.children
  }

  return (
    <EvergreenTooltip
      hideDelay={0}
      position={Position.TOP}
      showDelay={33}
      {...props}
      statelessProps={{
        backgroundColor: `rgb(var(--colorRgbFacetsNeutralDark700) / 95%)`,
        borderRadius: 6,
        // boxShadow: 'inset 0 0 4px rgba(0, 0, 0, 0.5)',
        className: 'swizzled-tooltip',
        maxWidth: 280,
        paddingX: 8,
        paddingY: 4,
        pointerEvents: 'none',
        ...props.statelessProps,
      }}
    />
  )
}
